import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, FormGroup } from 'react-bootstrap';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { cloneDeep } from 'lodash';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { checkArray, customStyles, checkIsNumber } from '../../../Components/helper';
import CustomDatePicker from '../../../Components/Utility/DatePicker/DatePicker';
import Spinner from '../../../Components/LogoSpinner/Spinner';
import { useProductListingState } from './RangePlanProductListingProvider';
import * as ProductListAction from './store/ProductList.action';

function BulkManualModal({ show, toggle, showLoader, selectedIds }) {
  const [selectedFields, setSelectedFields] = useState([]);
  const { t } = useTranslation('common');

  const {
    rangePlanProvider: { manualList, selectedSection },
    setRangePlanProvider,
  } = useProductListingState();
  const dispatch = useDispatch();

  useEffect(() => {
    const checkedField = checkArray(manualList) && manualList.filter((ele) => ele.isChecked);
    setSelectedFields(checkedField);
  }, []);

  const handleInputSelect = (val, id) => {
    const copyState = cloneDeep(selectedFields);
    const index = copyState.findIndex((x) => x._id === id);
    copyState[index].value = val;
    setSelectedFields(copyState);
  };
  const handleCheckbox = (val, ind, id, isRadio) => {
    const copyState = cloneDeep(selectedFields);
    const index = copyState.findIndex((x) => x._id === id);
    if (isRadio) {
      copyState[index].options.map((ele) => (ele.checked = false));
    }
    copyState[index].options[ind].checked = val;
    setSelectedFields(copyState);
  };

  const renderField = (eleField, pIndex) => {
    switch (eleField.type) {
      case 'Dropdown':
        return (
          <div className="common-react-select">
            <p className="field-name">{eleField.label}</p>
            <Select
              options={eleField.options}
              value={eleField?.value}
              onChange={(e) => handleInputSelect(e, eleField._id)}
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option._id}
              styles={customStyles}
              placeholder={eleField.label}
            />
          </div>
        );
      case 'Textbox':
        return (
          <div className="common-input-control">
            <p className="field-name">{eleField.label}</p>
            <input
              type="text"
              value={eleField?.value || ''}
              placeholder={eleField.label}
              className="form-control"
              onChange={(e) => handleInputSelect(e.target.value, eleField._id)}
            />
          </div>
        );
      case 'Checkbox':
        return (
          <>
            <label className="f-13 mb-0 h-20">{eleField.label}</label>
            <div className="d-flex align-items-center flex-wrap">
              {eleField.options.map((eleCheck, i) => {
                const keyId = eleCheck;
                return (
                  <div key={keyId} className="common-checkbox mr-2">
                    <input
                      type="checkbox"
                      id={`checkbox${i}_${pIndex}`}
                      checked={eleCheck.checked}
                      onChange={(e) => handleCheckbox(e.target.checked, i, eleField._id, false)}
                    />
                    <label htmlFor={`checkbox${i}_${pIndex}`} className="chklabel">
                      <span>{eleCheck.name}</span>
                    </label>
                  </div>
                );
              })}
            </div>
          </>
        );
      case 'Radio_button':
        return (
          <>
            <label className="f-13 mb-0 h-20">{eleField.label}</label>
            <div className="d-flex align-items-center flex-wrap">
              {eleField.options.map((eleRadio, i) => {
                const keyId = eleRadio;
                return (
                  <p key={keyId} className="custom-radio mr-2 mb-0">
                    <input
                      type="radio"
                      id={`radio${i}_${pIndex}`}
                      name={`dynamicName__${pIndex}`}
                      value={eleRadio.name}
                      onChange={(e) => handleInputSelect(e.target.value, eleField._id)}
                    />
                    <label htmlFor={`radio${i}_${pIndex}`}>{eleRadio.name}</label>
                  </p>
                );
              })}
            </div>
          </>
        );
      case 'Date_picker':
        return (
          <div className="common-input-control">
            <p className="field-name">{eleField.label}</p>

            <div className="icon-container">
              <CustomDatePicker
                valueProp={eleField.value ? new Date(eleField.value) : null}
                dateFormat="dd-MMM-yyyy"
                popperPlace="bottom-end"
                name="selectedDate"
                onChange={(date_) => handleInputSelect(date_, eleField._id)}
              />
            </div>
          </div>
        );
      case 'Time_picker':
        return (
          <div className="common-input-control">
            <p className="field-name">{eleField.label}</p>
            <div className="icon-container">
              <DatePicker
                selected={eleField.value ? new Date(eleField.value) : null}
                popperPlacement="bottom-end"
                name="selectedDate"
                showTimeSelect
                timeIntervals={5}
                timeCaption="Time"
                timeFormat="HH:mm"
                dateFormat="HH:mm"
                showTimeSelectOnly
                onChange={(time_) => handleInputSelect(time_, eleField._id)}
              />
              <span className="icon-clock" />
            </div>
          </div>
        );
      case 'Textarea':
        return (
          <>
            <label className="f-13 mb-0 h-20">{eleField.label}</label>
            <textarea
              value={eleField.value || ''}
              className="form-control text-bordered textarea"
              onChange={(e) => handleInputSelect(e.target.value, eleField._id)}
            />
          </>
        );
      case 'Number':
        return (
          <div className="common-input-control">
            <p className="field-name">{eleField.label}</p>
            <input
              type="text"
              value={eleField.value || ''}
              placeholder={eleField.label}
              className="form-control"
              onChange={(e) => {
                if (checkIsNumber(e.target.value)) handleInputSelect(e.target.value, eleField._id);
              }}
            />
          </div>
        );
      case 'Number_percentage':
        return (
          <div className="common-input-control">
            <p className="field-name">{eleField.label} (%)</p>
            <input
              type="text"
              value={eleField.value || ''}
              placeholder={eleField.label}
              className="form-control"
              onChange={(e) => {
                if (checkIsNumber(e.target.value)) handleInputSelect(e.target.value, eleField._id);
              }}
            />
          </div>
        );

      default:
        break;
    }
  };

  const hadleSumbitBulkManual = async () => {
    const columns = selectedFields.map((element) => {
      if (element.type === 'Checkbox') {
        const items = element?.options.map((eleOpt, i) => {
          return { [i]: eleOpt.checked ? eleOpt.checked : false };
        });
        return {
          columnId: element._id,
          value: Object.assign({}, ...items),
        };
      }
      return {
        columnId: element._id,
        value: element?.value,
      };
    });
    const customBulkData = {
      devOrderIds: selectedIds,
      type: 'custom-section',
      data: columns,
      sectionId: selectedSection?.value,
    };
    const res = await dispatch(ProductListAction.bulkExchangeRateUpdate(customBulkData, t));
    if (res) {
      if (res.code === 200) {
        toggle();
        setRangePlanProvider((prevState) => ({
          ...prevState,
          selectedSection: null,
          manualList: [],
        }));
      }
    }
  };
  return (
    <Modal className="common-custom-modal bulk-manual-modal" size="md" show={show} onHide={toggle} backdrop="static">
      <Modal.Header>
        <Modal.Title> {t('RANGE_PLANS.PRODUCT_LIST.BULK_MANUAL_MODAL.UPDATE_PRODUCTS')}</Modal.Title>
        <span onClick={toggle} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        {showLoader ? (
          <Spinner />
        ) : (
          <Row>
            {checkArray(selectedFields) &&
              selectedFields.map((eleField, i) => {
                const keyID = eleField;
                return (
                  <Col key={keyID} md={6}>
                    <FormGroup className="mb-2">{renderField(eleField, i)}</FormGroup>
                  </Col>
                );
              })}
          </Row>
        )}
        <div className="common-model-footer mt-24 ">
          <button className="btn p-0" type="button" onClick={hadleSumbitBulkManual} aria-label={t('RANGE_PLANS.PRODUCT_LIST.BULK_MANUAL_MODAL.SAVE_BUTTON')}>
            <span className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default BulkManualModal;
